import React from 'react'
import PropTypes from 'prop-types'

import { Toast, Typography } from '@chilecompra/react-kit/components'

import { GridContainer, GridItem, LinkDocument } from './QuoteBasicInformation.styles'

/**
 * The Quote Bid information Alert's component.
 */
const QuoteBasicInformationAlert = props => {
  const { purcharseOrderStatus, onDialogAlert } = props

  return (
    <Toast align="left" severity="info">
      <GridContainer xs={12}>
        <GridItem xs={12}>
          <Typography fontSize="14px" fontWeight="bold" lineHeight="16px" variant="body2">
            La orden de compra ha sido {purcharseOrderStatus?.statusCancelled ? 'cancelada' : 'eliminada'}
          </Typography>
          <Typography fontSize="14px" lineHeight="18px" margin="0 0 10px" variant="body2">
            {purcharseOrderStatus?.allowChange
              ? `La solicitud volverá a estado cerrada. Al confirmar, podrás elegir otra cotización de esta Compra Ágil y
              enviar la orden al mismo proveedor de la anterior ${purcharseOrderStatus?.statusCancelled ? ' cancelada' : ' eliminada'} o a otro.`
              : `Puedes seleccionar otra cotización de esta misma Compra Ágil. La solicitud volverá a estado cerrada para que puedas retomar el proceso.`}
          </Typography>
          <LinkDocument onClick={onDialogAlert}>
            {purcharseOrderStatus?.allowChange
              ? 'Confirmar y seleccionar otra cotización'
              : 'Entendido, no volver a mostrar este mensaje'}
          </LinkDocument>
        </GridItem>
      </GridContainer>
    </Toast>
  )
}

QuoteBasicInformationAlert.propTypes = {
  onDialogAlert: PropTypes.func.isRequired,
  purcharseOrderStatus: PropTypes.shape({
    allowChange: PropTypes.bool,
    statusRemoved: PropTypes.bool,
    statusCancelled: PropTypes.bool
  })
}

export default QuoteBasicInformationAlert
